import React, { Component } from 'react';
import { string, func, object, oneOfType } from 'prop-types';
import { map, get, filter, some, includes, isEmpty, slice } from 'lodash';
import { withApollo } from 'react-apollo';
import PerformCleanOrder from '../../graphql/performCleanOrder';
import { CANCEL_ORDER } from '../../graphql/performCancelOrder';
import { OrderAuditManagementConsumer } from '../../firebase/OrderAuditManagement';
import ModifyShipping from '../ModifyShipping';
import CancelOrder from '../CancelOrder/CancelOrder';
import UserSession from '../../auth/UserSession';
import { Auth } from 'aws-amplify';
import withFirebase from '../../../hoc/withFirebase';
import { Text, Button, Title, IconContainer, Icon, Column, Row, Drawer, DrawerHeader, Loading, FlexContainer, MobileWrapper, IsMobileWrapper } from '../../common';
import { urlSisa, urlBase } from './../../../components/utils/changeUrlSisa';
import { GREEN_DARK } from '../../../utils/colors';

let colorChange = '#4cb358';

if (urlSisa() == urlBase()) {
    colorChange = '#4daea9';
}

const DefaultComponent = ({ children, ...props }) => children({ ...props });

class OrderActions extends Component {
    constructor (props) {
        super(props);
        this.state = {
            opened: false,
            onClick: () => { },
            text: null,
            render: null,
            user: '',
            phone: '',
            contactType: '',
            comment: '',
            loading: false,
            drawerClosable: false,
            currentUserInfo: get(props, 'currentUserInfo', {}),
            drawerSizes: ['25%', '25%', '100%'],
            traceCancelOrder: {}
        };
    }

    async componentDidMount () {
        try {
            this.setState({ loading: true });
            const currentUserInfo = await Auth.currentSession();
            this.setState({ currentUserInfo, loading: false });
        } catch (error) {
            console.log(error, this.setState({ loading: false }));
        }
    }

    confirmationInitialState = {
        opened: false,
        drawerSizes: ['25%', '25%', '100%'],
        drawerClosable: false,
        onClick: () => { },
        text: null,
        render: null,
        loading: false
    }

    resetDrawer = () => this.setState(this.confirmationInitialState)

    isDisabled = (id, type) => {
        const { lastKnownStatus } = this.props;
        const lastStatus = get(lastKnownStatus, 'code', get(this.props, 'assignInfo.status.code'));

        switch (id) {
        case 'audit_reasons':
            // return ['1', '2', '20'].includes(lastStatus) || isNil(get(groupBy(get(pickingTime, 'stats'), 'field'), 'audit.0.end'))
            return false;
        case 'audit':
            return ['1', '20', '3', '4', '6', '7', '8', '9', '34', '21', '41', '50', '51', '53', '54', '58', '5', '57', '55', '59', '60'].includes(lastStatus);
        case 'assign_picker':
            return ['3', '8', '9', '31', '4', '21', '41', '50', '51', '53', '54', '58', '5', '57', '55', '59', '60'].includes(lastStatus);
        case 'modify_shipping':
            //return !['1', '2', '3', '4', '6', '7', '20', '30', '31', '32', '33', '34'].includes(lastStatus);
            return !['1', '2', '9', '20'].includes(lastStatus);
        case 'modify_shipping_oper': // Actual Drawer Shipping Method
        case 'capacity_scheduling':
            //return includes(['41'], lastStatus);
            return !includes(['1', '2', '20'], lastStatus);
        case 'cancel':
            return !['1', '2', '3', '4', '6', '7', '20', '30', '32', '34'].includes(lastStatus);
        case 'clean-order':
            return ['8', '41', '50', '51', '53', '54', '58', '5', '57', '55', '59', '60'].includes(lastStatus);
        case 'order_sheet':
            return !['4', '5', '8', '9', '50', '51', '53', '54', '57', '58', '55', '59', '60'].includes(lastStatus);
        case 'dispatch_sheet':
            return !['5', '50', '51', '53', '54', '57', '58', '55', '59', '60'].includes(lastStatus);
        case 'email_order_invoice':
            return !['5', '50', '51', '53', '54', '57', '58', '55', '59', '60'].includes(lastStatus);
        case 'shopper_calls':
            return ['8'].includes(lastKnownStatus);
        case 'bagging_images':
            return false;
        default:
            if (!['1', '2', '3', '4', '5', '8', '9'].includes(lastStatus) && type === 'queries') return false;
            if (!['1', '2', '3', '4', '5', '8', '9'].includes(lastStatus) && type === 'actions') return true;
        }
    }

    buttons = {
        queries: [
            {
                name: 'Historial de Auditorías',
                icon: 'document',
                id: 'audit_reasons',
                permissions: ['order-detail-page:audit-history'],
                onClick: () => this.props.toggleAuditDrawer({ history: true })
            },
            {
                name: 'logs',
                icon: 'layers',
                id: 'logs',
                permissions: ['order-detail-page:logs']
            },
            {
                name: 'Historial y Contactos',
                icon: 'phone',
                id: 'call_history',
                permissions: ['order-detail-page:call&contact-history'],
                onClick: () => this.props.onClickCallHistory('call_history')
            },
            {
                name: 'Bitácora',
                icon: 'document',
                id: 'logbook',
                permissions: ['order-detail-page:call&contact-history'],
                onClick: () => this.props.onClickCallHistory('logbook')
            },
            {
                name: 'Historial de llamadas y chat',
                icon: 'phone-rigning',
                id: 'shopper_calls',
                onClick: () => this.props.onClickCallHistory('shopper_calls')
            },
            {
                name: 'Embolsado',
                icon: 'bag-menu',
                id: 'bagging_images',
                permissions: ['order-detail-page:bagging-images'],
                onClick: () => this.props.toggleBaggingImagesDrawer()
            },
            {
                name: 'Imprimir hoja de despacho',
                icon: 'clipboard',
                id: 'order_sheet',
                permissions: ['order-detail-page:print-order-detail-page'],
                onClick: () => window.open(`/order-pdf/${this.props.orderId}`, '_blank')
            },
            {
                name: 'Imprimir hoja de pedido',
                icon: 'blank-sheet',
                id: 'dispatch_sheet',
                permissions: ['order-detail-page:print-dispatch-page'],
                onClick: () => window.open(`/dispatch-pdf/${this.props.orderId}`, '_blank')
            },
            {
                name: 'Mail de pedido Facturado',
                icon: 'envelope',
                id: 'email_order_invoice',
                permissions: ['order-detail-page:email-order-invoice'],
                onClick: () => this.props.toggleMailOrderInvoiced({ history: true })
            }
        ],
        actions: [
/*             {
                name: 'modificar envío',
                id: 'modify_shipping',
                permissions: ['order-detail-page:modify-sales-channel'],
                onClick: () => this.setState({ opened: true, render: 'modifyShipping-form' })
            }, */
            {
                name: 'Reprogramar con capacidad',
                icon: 'clock',
                id: 'capacity_scheduling',
                permissions: ['order-detail-page:capacity_scheduling'],
                onClick: () => this.setState({ opened: true, render: 'capacity_scheduling' })
            },
            /*       {
        name: 'asignar pickeador',
        id: 'assign_picker',
        permissions: ['order-detail-page:assign-picker'],
        Component: ({ children }) => {
          return (
            <AssignPicker>
              {({ updateFn, loading }) => (
                <OrderPickerManager
                  render={() => (
                    <Button
                      key='assign_picker'
                      disabled={this.isDisabled('assign_picker', 'queries')}
                      top={6}
                      bottom={6}
                      secondary
                      text='Asignar Shopper'
                    />
                  )}
                  filters={{
                    filters: [
                      { field: 'salesChannels', value: [get(this.props, 'salesChannel.id', '1')] },
                      { field: 'statusUser', value: ['0'] }
                    ]
                  }}
                  onSelectPicker={({ value }) => Promise.resolve(
                    updateFn({
                      variables: {
                        input: { orderId: get(this.props, 'id'), userId: value }
                      }
                    })
                  )}
                  loading={loading}
                  {...this.props}
                />
              )}
            </AssignPicker>
          )
        }
      }, */
            {
                name: 'Reiniciar Pedido',
                icon: 'restart',
                id: 'clean-order',
                permissions: ['order-detail-page:reset-order'],
                Component: ({ children }) => (
                    <PerformCleanOrder>
                        {({ updateFn, loading }) => children({
                            onClickProp: () => {
                                const { currentUserInfo } = this.state;
                                const { email, phone_number } = get(currentUserInfo, 'idToken.payload', { email: 'Sin email', phone_number: '' });
                                this.setState({
                                    opened: true,
                                    text: '¿Estas seguro de reiniciar el pedido? Los datos del picking seran eliminados.',
                                    render: 'confirm',
                                    onClick: () => {
                                        this.setState({ loading: true }, () => {
                                            updateFn({
                                                variables: {
                                                    orderId: this.props.orderId,
                                                    user: email,
                                                    phone: phone_number
                                                }
                                            }).then(() => {
                                                this.resetDrawer();
                                                this.props.onClose();
                                            });
                                        });
                                    }
                                });
                            }
                        })}
                    </PerformCleanOrder>
                )
            },
            {
                name: 'anular pedido',
                icon: 'cross',
                id: 'cancel',
                permissions: ['order-detail-page:cancel-order'],
                onClick: () => this.setState({
                    opened: true,
                    render: 'cancel-form'
                })
            },
            {
                name: 'auditar',
                icon: 'voice',
                id: 'audit',
                permissions: ['order-detail-page:audit-order'],
                Component: ({ children }) => (
                    <OrderAuditManagementConsumer orderId={this.props.orderId}>
                        {({ taken }) => children({
                            // isDisabled: taken,
                            onClickProp: () => this.props.toggleAuditDrawer({ audit: true })
                        })}
                    </OrderAuditManagementConsumer>
                )
            },
            {
                name: 'Contingencia',
                icon: 'calendar-clock',
                id: 'modify_shipping_oper',
                permissions: ['order-detail-page:modify-sales-channel-oper'],
                onClick: () => this.setState({ opened: true, render: 'modify_shipping_oper' })
            }
        ]
    }

    ActionDetail = ({ session }) => {
        const {
            client,
            orderId,
            onClose,
            logisticsInfo,
            lastKnownStatus,
            storeName,
            customer,
            selectedAddress,
            salesChannel,
            idStore,
            storeKind,
            createdAt
        } = this.props;
        const { render, text, onClick, loading, currentUserInfo } = this.state;
        const { email, phone_number } = get(currentUserInfo, 'idToken.payload', { email: 'Sin email', phone_number: '' });
        switch (render) {
        case 'modifyShipping-form':
        case 'modify_shipping_oper':
        case 'capacity_scheduling':
            const isCapacity = includes(render, 'capacity_scheduling');
            const properties = { salesChannel, idStore, email, orderId, logisticsInfo, storeName, customer, selectedAddress, storeKind, session, isCapacity, createdAt };
            return (
                <Column>
                    <DrawerHeader title={'Reprogramar Pedido'} onClose={this.resetDrawer} />
                    <ModifyShipping
                        orderStatus={lastKnownStatus}
                        onCancel={this.resetDrawer}
                        onSubmited={() => {
                            this.resetDrawer();
                            onClose();
                        }}
                        {...properties}
                    />
                </Column>
            );
        case 'cancel-form':
            return (
                <Column>
                    <DrawerHeader title='Anular Pedido' onClose={this.resetDrawer} />
                    <CancelOrder
                        loading={loading}
                        orderId={orderId}
                        currentUserInfo={currentUserInfo}
                        resetDrawer={this.resetDrawer}
                        onSubmit={(comment, contactType) => {
                            this.setState({
                                opened: true,
                                render: 'confirm',
                                text: '¿Estas seguro de anular el pedido?',
                                onClick: () => {
                                    this.setState({
                                        traceCancelOrder: this.props.firebasePerformance.trace('CANCEL_ORDER')
                                    }, () => {
                                        // Firebase: Starts the timing for the trace instance
                                        this.state.traceCancelOrder.start();
                                    });

                                    this.setState({ loading: true }, async () => {
                                        const { data } = await client.mutate({
                                            mutation: CANCEL_ORDER,
                                            variables: {
                                                input: { id: orderId, comment, contactType, user: email, phone: phone_number }
                                            }
                                        });
                                        const { status } = get(data, 'cancelOrderById', null);
                                        if (status === 'canceled') {
                                            // Firebase: Stop the timing for the trace instance
                                            this.state.traceCancelOrder.stop();
                                            this.resetDrawer();
                                            onClose();
                                        } else {
                                            this.setState({ loading: false, text: 'Hubo un error al Anular pedido. ¿Deseas reintentar?' });
                                        }
                                    });
                                }
                            });
                        }}
                />
                </Column>
            );
        case 'confirm':
            return (
                <Column center>
                    <IconContainer color='#f38630' margin='0 0 40px 0'>
                        <Icon name='caution' size={43} color='#ffffff' />
                    </IconContainer>
                    <Text text={text} size={14} centered />
                    <Row noFlex noWrap mT={40}>
                        <Button text='Cancelar' style={{ color: colorChange }} disabled={loading} link onClick={() => this.resetDrawer()} right={5} />
                        <Button text='Confirmar' loading={loading} width={110} onClick={() => onClick()} left={5} />
                    </Row>
                </Column>
            );
        default:
            return null;
        }
    }

    _getAvailableActions = (session, actionType) => {
        const resources = get(session, 'resources');
        const actions = get(this.buttons, actionType, 'queries');
        return filter(actions, ({ permissions = [] }) => (
            isEmpty(permissions) || some(permissions, (resource) => includes(resources, resource)
            )));
    }

    render () {
        const { opened, drawerSizes } = this.state;
        const { orderId } = this.props;
        const titleProps = { upperCase: true, size: 12, fontWeight: 600, color: GREEN_DARK };
        return (
            <UserSession typeCache>
                {({ loading, session }) => (
                    <Loading loading={loading}>
                        <FlexContainer flex={1} direction='column'>
                            <MobileWrapper hide showDesktop>
                                <FlexContainer direction='column'>
                                    <Title text='consultas' {...titleProps} />
                                    {map(this._getAvailableActions(session, 'queries'), ({ name, Component = DefaultComponent, onClick, id, icon }, index) => (
                                        <Component id={orderId} key={index}>
                                            {({ loading = false, onClickProp = null, isDisabled = false }) => (
                                                <Button
                                                    key={index}
                                                    loading={loading}
                                                    onClick={onClickProp || onClick}
                                                    disabled={isDisabled || this.isDisabled(id, 'queries')}
                                                    top={6}
                                                    bottom={6}
                                                    flat
                                                    text={name}
                                                    icon={icon}
                                                />
                                            )}
                                        </Component>
                                    ))}
                                </FlexContainer>
                                <FlexContainer direction='column' mT={30}>
                                    <Title text='acciones' {...titleProps} />
                                </FlexContainer>
                            </MobileWrapper>
                            <IsMobileWrapper>
                                {({ isMobile }) => {
                                    const actionButtons = this._getAvailableActions(session, 'actions');
                                    return (
                                        <FlexContainer direction='column'>
                                            {map(isMobile ? slice(actionButtons, 1, 4) : actionButtons, ({ name, Component = DefaultComponent, onClick, id, icon }, index) => (
                                                <Component key={index}>
                                                    {({ loading = false, onClickProp = null, isDisabled = false }) => (
                                                        <Button
                                                            loading={loading}
                                                            key={index}
                                                            onClick={onClickProp || onClick}
                                                            disabled={isDisabled || this.isDisabled(id, 'actions')}
                                                            top={6}
                                                            bottom={6}
                                                            text={name}
                                                            flat
                                                            icon={icon}
                                                        />
                                                    )}
                                                </Component>
                                            ))}
                                        </FlexContainer>
                                    );
                                }}
                            </IsMobileWrapper>
                        </FlexContainer>
                        <Drawer
                            values={drawerSizes}
                            visible={opened}
                            onClose={() => this.setState({ opened: false })}
                            minWidth='311px'
                        >
                            {this.ActionDetail({ session })}
                        </Drawer>
                    </Loading>
                )}
            </UserSession>
        );
    }
}

OrderActions.propTypes = {
    lastKnownStatus: oneOfType([string, object]),
    orderId: string,
    onClickCallHistory: func,
    toggleAuditDrawer: func,
    toggleMailOrderInvoiced: func,
    toggleBaggingImagesDrawer: func,
    onClose: func,
    logisticsInfo: object,
    client: object,
    storeName: string,
    customer: object,
    selectedAddress: object,
    firebasePerformance: object
};

OrderActions.defaultProps = {
    onClickAudit: () => (null),
    onClickOrderComments: () => (null),
    onClickCallHistory: () => (null),
    onClickCleanOrder: () => (null),
    toggleAuditDrawer: () => (null),
    toggleMailOrderInvoiced: () => (null),
    toggleBaggingImagesDrawer: () => {},
    operationInProgress: false
};

export default withApollo(withFirebase(OrderActions));